// src/ChartList.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const ChartList = () => {
  const [charts, setCharts] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCharts = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('/api/charts', {
          headers: { Authorization: `Bearer ${token}` }
        });
        setCharts(response.data);
      } catch (err) {
        console.error(err);
        setError("Erreur lors du chargement des charts.");
      }
    };
    fetchCharts();
  }, []);

  return (
    <div>
      <h2>Liste des Graphiques Sauvegardés</h2>
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {charts.length === 0 ? (
        <p>Aucun graphique sauvegardé.</p>
      ) : (
        <ul>
          {charts.map(chart => (
            <li key={chart.id}>
              <Link to={`/charts/embed/${chart.id}`}>{chart.title} - {chart.metal} - {JSON.parse(chart.dateRange).start}</Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ChartList;
